import { ActivityIndicator, Pressable, StyleSheet, Text } from "react-native";

import { action, radius, spacing, text, typography } from "@/src/theme/tokens";

type Props = {
  label: string;
  busyLabel?: string;
  busy?: boolean;
  disabled?: boolean;
  onPress: () => void;
};

export function PrimaryButton({ label, busyLabel, busy = false, disabled = false, onPress }: Props) {
  const unavailable = busy || disabled;
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityState={{ busy, disabled: unavailable }}
      disabled={unavailable}
      onPress={onPress}
      style={({ pressed }) => [styles.button, pressed && !unavailable && styles.pressed, unavailable && styles.disabled]}
    >
      {busy ? <ActivityIndicator color={text.inverse} size="small" /> : null}
      <Text style={styles.label}>{busy ? (busyLabel ?? label) : label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    backgroundColor: action.primary,
    borderRadius: radius.md,
    flexDirection: "row",
    gap: spacing.sm,
    justifyContent: "center",
    minHeight: 52,
    paddingHorizontal: spacing.lg,
    paddingVertical: spacing.md,
  },
  pressed: { backgroundColor: action.primaryPressed },
  disabled: { backgroundColor: action.disabled },
  label: {
    color: text.inverse,
    fontFamily: typography.family.semibold,
    fontSize: typography.size.body,
    lineHeight: typography.lineHeight.body,
  },
});
